<mat-form-field class="user-search-input-field" appearance="outline">
  <mat-icon matPrefix>search</mat-icon>
  <input
    matInput
    [matAutocomplete]="auto"
    [disabled]="disabled"
    [attr.aria-label]="'translations.global.ariaLabels.addNewMember' | transloco"
    [placeholder]="placeholder"
    (focus)="onFocus()"
    (paste)="onTextPaste($event)"
    (keyup)="onSearchInputChange($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    class="user-search-result-autocomplete"
    [displayWith]="disabledAutocomplete"
    [thresholdPercent]="0.9"
    (optionsScroll)="onAutocompleteScroll()"
    (optionSelected)="onMemberSelected($event)"
  >
    <mat-option *ngFor="let member of members" [value]="member" class="search-result-user-option">
      <div class="search-result-user-image">
        <img
          src="{{ member.image ? member.image : '../../../../assets/profile_image.png' }}"
          alt="{{ member.firstName && member.lastName ? member.firstName && member.lastName : member.name }}"
        />
      </div>
      <div class="search-result-user-bio">
        <div class="search-result-user-name small bold">
          {{ member.firstName && member.lastName ? member.firstName && member.lastName : member.name }}
        </div>
        <div *ngIf="member.email || member.externalId" class="search-result-user-email-id">
          <div *ngIf="member.email" class="search-result-user-email extra-small">
            {{ member.email }}
          </div>
          <div *ngIf="member.externalId" class="search-result-user-external-id extra-small">
            {{ member.externalId }}
          </div>
        </div>
      </div>
    </mat-option>

    <div class="loading-more-indicator" *ngIf="isLoadingMore">
      <mat-spinner class="loading-more-indicator__spinner" [diameter]="30"></mat-spinner>
    </div>
  </mat-autocomplete>
  <mat-icon aria-hidden="true" matSuffix class="flex">
    <mat-spinner *ngIf="loadingMembers" [diameter]="18"> </mat-spinner>
  </mat-icon>
</mat-form-field>
